import { Button, ButtonProps, Spinner } from '@uikit';

import { CanClaimOfferEntry } from '@shared/api/types/hotOffers';

export interface HotOfferClaimButtonProps extends ButtonProps<'button'> {
  isLoading: boolean;
  isCanClaimOfferLoading: boolean;
  canClaimOffer?: CanClaimOfferEntry;
}

export default function HotOfferClaimButton({
  isLoading,
  isCanClaimOfferLoading,
  canClaimOffer,
  ...props
}: HotOfferClaimButtonProps) {
  const isClaimed = canClaimOffer?.attributes?.claimed;

  const isDisabledButton = isCanClaimOfferLoading || isLoading;

  return (
    <Button
      {...(canClaimOffer?.attributes.claimUrl
        ? {
            as: 'a',
            href: canClaimOffer?.attributes.claimUrl,
            target: '_blank',
            rel: 'noreferrer',
          }
        : {})}
      size="lg"
      variant="secondary"
      className="flex-grow font-semibold h-[50px]"
      disabled={isDisabledButton}
      {...props}
    >
      {isClaimed && 'Offer Claimed'}

      {!isClaimed && (isLoading ? <Spinner size="md" color="light" /> : 'Claim Offer')}
    </Button>
  );
}
